import { LEReportData, ReportScore, ReportTreeNode } from '../types';

const genEmptyScoreData = () => {
  return {
    score: 0,
    max_score: 0,
    attempts: 0,
  } as ReportScore;
};

export const flattenTree = (tree: ReportTreeNode) => {
  const flattenedTree: { [key: string]: ReportScore } = {};
  const recursiveFlatten = (node: ReportTreeNode) => {
    flattenedTree[node.id] = genEmptyScoreData();
    node.subNodes.forEach((subNode) => recursiveFlatten(subNode));
  };
  recursiveFlatten(tree);
  return flattenedTree;
};

export const updateScoreData = (
  scoreData: LEReportData,
  userId: string,
  item: string,
  scoreObj: ReportScore,
) => {
  scoreData[userId][item].score += scoreObj.score;
  scoreData[userId][item].max_score += scoreObj.max_score;
  scoreData[userId][item].attempts += scoreObj.attempts;
};
